import type { IncidentStatus } from '../types/incident.types'
import {
  STATUS_DOT_CLASS,
  STATUS_LABELS,
  STATUS_TEXT_CLASS,
} from '../constants/incidentMaps'

interface StatusBadgeProps {
  status: IncidentStatus
}

export function StatusBadge({ status }: StatusBadgeProps): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium">
      <span
        data-testid="status-dot"
        className={`h-1.5 w-1.5 rounded-full ${STATUS_DOT_CLASS[status]}`}
      />
      <span className={STATUS_TEXT_CLASS[status]}>{STATUS_LABELS[status]}</span>
    </span>
  )
}
